
import { MapLocation } from '@/types/location';

// Cosmic Gym Locations
export const cosmicGyms: MapLocation[] = [
  {
    id: 3001,
    name: "Cosmic Gym - Riyadh (Al Yarmuk)",
    type: "Gym",
    devices: 2,
    coordinates: [24.802767237688638, 46.76702024662649],
    region: "Riyadh",
    mediaOwner: "Alan",
    mediaKind: "Indoor",
    screenType: "Landscape Screens",
    gender: "Female",
    ageRange: "22-45",
    orientation: "Landscape",
    segment: "Fitness"
  }
];
